import { AccountSettings } from '../account/AccountSettings';

/** An instructor's own account (2026-10-16): reached from her name in the rail, as she has no Settings. */
export function InstructorAccount({ onSignOut }: { onSignOut: () => void }) {
  return <AccountSettings onSignOut={onSignOut} nightsOnly />;
}
